import React from "react";
import ExistingOrderPage from "../components/ExistingOrderPage";

export default function OrdersEditPage() {
  return <ExistingOrderPage mode="edit" />;
}
